(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gs-header-cart-counter"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.__gsHeaderCartCountV1) return;
  window.__gsHeaderCartCountV1 = true;

  const selector = '.gs-header-cart-count';
  let version = 0;
  let inFlight = false;
  let readAgain = false;
  let timer;
  let subscribed = false;
  let attempts = 0;

  function itemCount(cart) {
    if (!cart || typeof cart !== 'object') return null;
    if (Number.isSafeInteger(cart.item_count) && cart.item_count >= 0) {
      return cart.item_count;
    }
    if (!Array.isArray(cart.items)) return null;
    let total = 0;
    for (const item of cart.items) {
      const quantity = Number(item.quantity);
      if (!Number.isSafeInteger(quantity) || quantity < 0) return null;
      total += quantity;
    }
    return Number.isSafeInteger(total) ? total : null;
  }

  function paint(count) {
    if (!Number.isSafeInteger(count) || count < 0) return;
    const text = String(count);
    document.querySelectorAll(selector).forEach((badge) => {
      const value = badge.querySelector('[data-gs-cart-count-value]');
      if (badge.dataset.gsCartCount !== text) badge.dataset.gsCartCount = text;
      if (value && value.textContent !== text) value.textContent = text;
    });
    // Preserve the theme's alternate text-navigation setting too.
    document.querySelectorAll('.gs-header-cart-link cart-count').forEach((node) => {
      if (node.textContent !== text) node.textContent = text;
    });
  }

  function accept(cart) {
    const count = itemCount(cart);
    if (count === null) return;
    version += 1;
    paint(count);
  }

  function scheduleRead() {
    window.clearTimeout(timer);
    timer = window.setTimeout(readCart, 180);
  }

  async function readCart() {
    if (!document.querySelector(selector)) return;
    if (inFlight) {
      readAgain = true;
      return;
    }
    inFlight = true;
    const startedAtVersion = version;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(root + 'cart.js', {
        method: 'GET',
        credentials: 'same-origin',
        cache: 'no-store',
        headers: { Accept: 'application/json' }
      });
      if (!response.ok) return;
      const cart = await response.json();
      // Never replace a newer app/theme event with an older in-flight response.
      if (version === startedAtVersion) {
        const count = itemCount(cart);
        if (count !== null) paint(count);
      }
    } catch (_) {
      // Keep the last confirmed quantity when the network is unavailable.
    } finally {
      inFlight = false;
      if (readAgain) {
        readAgain = false;
        scheduleRead();
      }
    }
  }

  function subscribeUpcart() {
    if (subscribed || typeof window.upcartSubscribeCartLoaded !== 'function') return;
    try {
      window.upcartSubscribeCartLoaded((event) => accept(event?.cart));
      subscribed = true;
    } catch (_) {
      // The read-only Shopify fallback remains available during app startup.
    }
  }

  function waitForUpcart() {
    subscribeUpcart();
    attempts += 1;
    if (!subscribed && attempts < 80) window.setTimeout(waitForUpcart, 250);
  }

  ['cart:change', 'variant:add', 'line-item:change'].forEach((name) => {
    document.addEventListener(name, (event) => accept(event.detail?.cart));
  });
  ['cart:refresh', 'cart:error', 'shopify:section:load'].forEach((name) => {
    document.addEventListener(name, () => {
      subscribeUpcart();
      scheduleRead();
    });
  });

  // Observe completed cart requests without replacing fetch, XHR or app callbacks.
  if ('PerformanceObserver' in window) {
    try {
      const observer = new PerformanceObserver((list) => {
        const cartChanged = list.getEntries().some((entry) => {
          try {
            const url = new URL(entry.name, window.location.href);
            return url.origin === window.location.origin &&
              /\/cart\/(add|change|update|clear)(\.(js|json))?\/?$/.test(url.pathname);
          } catch (_) {
            return false;
          }
        });
        if (cartChanged) {
          subscribeUpcart();
          scheduleRead();
        }
      });
      observer.observe({ type: 'resource', buffered: true });
    } catch (_) {
      // Documented theme and Upcart events remain the primary update paths.
    }
  }

  window.addEventListener('pageshow', () => {
    subscribeUpcart();
    scheduleRead();
  });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      subscribeUpcart();
      scheduleRead();
    }
  });

  waitForUpcart();
  scheduleRead();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gs-ux-assets"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (window.__gsPremiumProductUxV2) return;
  window.__gsPremiumProductUxV2 = true;
  const states = new WeakMap();
  const normalise = value => String(value || '').replace(/\s+/g, ' ').trim().toLocaleLowerCase();
  const sizePattern = /größe|grösse|size|taille|talla/;
  const visible = el => el && !el.closest('[hidden], [aria-hidden="true"]') &&
    getComputedStyle(el).display !== 'none' && getComputedStyle(el).visibility !== 'hidden';

  function enhance(section, state) {
    const info = section.querySelector('.gs-ux-pdp');
    const config = section.querySelector('template[data-gs-ux-product-options]');
    if (!info || !config) return;
    if (state.info !== info) { state.info = info; state.kiwi = null; state.note = null; }

    const colours = config.content.querySelector('.gs-ux-colors--product');
    if (colours && !info.querySelector('.gs-ux-colors--product')) {
      let host = info.querySelector('[data-block-type="product-variations"]');
      if (!host) {
        const variantBlock = info.querySelector('[data-block-type="variant-picker"]');
        if (variantBlock) {
          host = document.createElement('div');
          host.className = 'product-info__block-item';
          host.dataset.blockType = 'product-variations';
          variantBlock.before(host);
        }
      }
      if (host) host.replaceChildren(colours.cloneNode(true));
    }

    const labels = String(config.dataset.gsSizeLabel || '').split(',').map(normalise);
    const field = Array.from(info.querySelectorAll('variant-picker fieldset')).find(el => {
      const text = normalise(el.querySelector('legend')?.textContent).replace(/:$/, '');
      return text && (labels.includes(text) || sizePattern.test(text));
    });
    const header = field?.querySelector('.variant-picker__option-info');
    if (!header) return;

    const note = field.querySelector('.gs-ux-fit-note') ||
      Array.from(info.querySelectorAll('.gs-fit-note')).find(el => !el.closest('variant-picker')) || state.note;
    if (note) {
      state.note = note;
      if (!field.contains(note)) {
        const origin = note.closest('.product-info__block-item');
        note.classList.add('gs-ux-fit-note');
        header.after(note);
        if (origin && !origin.contains(field)) origin.dataset.gsUxEmptiedFit = 'true';
      }
    }

    // Restore our own temporary duplicate markers before choosing the current real widget.
    info.querySelectorAll('[data-gs-ux-guide-duplicate]').forEach(el => el.removeAttribute('data-gs-ux-guide-duplicate'));
    const kiwiWidgets = Array.from(info.querySelectorAll('.ks-chart-container')).filter(el =>
      el.textContent.trim() && !el.parentElement?.closest('.ks-chart-container') && !el.closest('x-modal, .modal, [role="dialog"]') && visible(el));
    let kiwi = kiwiWidgets.find(el => header.contains(el)) || kiwiWidgets[0];
    if (!kiwi && state.kiwi && !state.kiwi.isConnected) kiwi = state.kiwi;
    const nativeGuide = header.querySelector('button[aria-controls^="size-chart-"]');

    if (kiwi) {
      state.kiwi = kiwi;
      const origin = kiwi.closest('.product-info__block-item');
      if (!header.contains(kiwi)) header.append(kiwi);
      kiwi.classList.add('gs-ux-kiwi-guide');
      if (origin && !origin.contains(field) && !origin.textContent.trim() && !origin.querySelector('input, button, a, iframe')) {
        origin.dataset.gsUxEmptiedGuide = 'true';
      }
      header.querySelectorAll('[data-gs-ux-size-help]').forEach(el => el.remove());
      if (nativeGuide) nativeGuide.dataset.gsUxGuideDuplicate = 'true';
      kiwiWidgets.filter(el => el !== kiwi && normalise(el.textContent) === normalise(kiwi.textContent))
        .forEach(el => { el.dataset.gsUxGuideDuplicate = 'true'; });
      return;
    }
    if (nativeGuide) {
      nativeGuide.classList.add('gs-ux-size-help');
      header.querySelectorAll('[data-gs-ux-size-help]').forEach(el => el.remove());
      return;
    }
    // Without an installed chart, one fallback opens the existing size/fit accordion.
    const accordion = Array.from(info.querySelectorAll('details.accordion')).find(el =>
      sizePattern.test(normalise(el.querySelector('summary')?.textContent)));
    const summary = accordion?.querySelector('summary');
    if (!summary) { header.querySelector('[data-gs-ux-size-help]')?.remove(); return; }
    let help = header.querySelector('[data-gs-ux-size-help]');
    if (!help) {
      help = document.createElement('button');
      help.type = 'button';
      help.className = 'gs-ux-size-help';
      help.dataset.gsUxSizeHelp = 'true';
      help.addEventListener('click', () => {
        const target = Array.from(info.querySelectorAll('details.accordion')).find(el =>
          sizePattern.test(normalise(el.querySelector('summary')?.textContent)));
        const toggle = target?.querySelector('summary');
        if (!toggle) return;
        if (!target.open) toggle.click();
        requestAnimationFrame(() => {
          toggle.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
      header.append(help);
    }
    const text = summary.textContent.trim();
    if (help.textContent !== text) help.textContent = text;
  }

  function mount(section) {
    if (states.has(section)) return;
    const state = { info: null, kiwi: null, note: null, queued: false, observer: null };
    const options = { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'hidden'] };
    const run = () => {
      state.queued = false;
      state.observer.disconnect();
      if (!section.isConnected) return;
      try { enhance(section, state); }
      finally { state.observer.observe(section, options); }
    };
    state.observer = new MutationObserver(() => {
      if (!state.queued) { state.queued = true; requestAnimationFrame(run); }
    });
    states.set(section, state);
    run();
  }
  function initialise(root = document) {
    if (root.matches?.('.shopify-section--main-product')) mount(root);
    root.querySelectorAll?.('.shopify-section--main-product').forEach(mount);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(), { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('shopify:section:unload', event => {
    states.get(event.target)?.observer.disconnect(); states.delete(event.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  if (customElements.get('gs-search-defaults')) return;
  class GsSearchDefaults extends HTMLElement {
    connectedCallback() {
      this.host = this.closest('header-search');
      this.form = this.host?.querySelector('form[role="search"]');
      this.input = this.form?.querySelector('input[name="q"]');
      this.clear = this.form?.querySelector('[data-gs-search-clear]');
      if (!this.host || !this.input || !this.clear) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const sync = () => {
        const hasQuery = this.input.value.trim().length > 0;
        this.hidden = hasQuery;
        this.clear.hidden = !hasQuery;
        this.host.dataset.gsSearchState = hasQuery ? 'query' : 'empty';
      };
      this.input.addEventListener('input', sync, options);
      this.input.addEventListener('search', sync, options);
      this.input.addEventListener('change', sync, options);
      this.input.addEventListener('focus', sync, options);
      this.clear.addEventListener('click', () => {
        this.input.value = '';
        this.input.dispatchEvent(new Event('input', { bubbles: true }));
        this.input.focus();
      }, options);
      this.form.addEventListener('reset', () => {
        requestAnimationFrame(() => { if (this.isConnected) sync(); });
      }, options);
      window.addEventListener('pageshow', sync, options);
      sync();
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  customElements.define('gs-search-defaults', GsSearchDefaults);
})();
  } catch(e) { console.error(e); }
})();

})();
